var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-wrapper"},[(!!_vm.$slots['table-header'])?_c('div',{staticClass:"table-header"},[_vm._t("table-header")],2):_vm._e(),_c('div',{class:`table-container nice-scrollbar ${_vm.overflowAll ? 'overflow-all' : ''}`},[_c('table',[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }